<template>
  <div class="aboutus">
    <div class="image-container">
      <img
        src="../../assets/gywmdb.png"
        alt="Sample Image"
        class="aboutusimg"
      />
      <el-button type="primary" class="btn" @click="goBottom"
        >联系我们</el-button
      >
    </div>
    <div class="box">
      <!-- 定制化服务 -->
      <div class="custom">
        <div class="service">
          <h5>
            <div>“</div>
            <span class="spans">定制化服务</span>
            <div>”</div>
          </h5>
          <div class="servicex">Customized service</div>
        </div>
        <div class="customx">
          <ul>
            <li>
              <div class="round">
                <i class="iconfont gos-shejiguifan gos"></i>
              </div>
              <h4>课程设计</h4>
              <p>根据老师讲课方式，结合平台资源，设计更清晰的课件</p>
            </li>
            <li>
              <div class="round">
                <i class="iconfont gos-zuoyeguanli gos"></i>
              </div>
              <h4>课程制作</h4>
              <p>录制老师上课的讲解视频,为学生提供平台免费资源进行训练</p>
            </li>
            <li>
              <div class="round">
                <i class="iconfont gos-shipin gos"></i>
              </div>
              <h4>课程视频展示</h4>
              <p>
                上传老师讲课视频，在平台展示提供给更多人学习。增加老师知名度
              </p>
            </li>
            <li>
              <div class="round">
                <i class="iconfont gos-daimashili gos"></i>
              </div>
              <h4>免费资源</h4>
              <p>结合制作课程涉及到的资源，为学生提供免费的软件进行训练</p>
            </li>
          </ul>
        </div>
      </div>
      <!-- 企业介绍 -->
      <div class="introduce">
        <div class="service">
          <h5>
            <div>“</div>
            <span class="spans">府学介绍</span>
            <div>”</div>
          </h5>
          <div class="servicex">University Introduction</div>
        </div>
        <div class="introducex">
          <div class="introducex-x">
            <img
              style="width: 100%; height: 100%"
              src="../../assets/zjtus.png"
              alt=""
            />
          </div>
          <div class="introducex-rigth">
            <h4>幕课 府学</h4>
            <h5>MOOC University</h5>
            <p align="left" style="margin-top: -20px">
              &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;www.幕课.com
              &nbsp;
              是一个专注医学、医疗领域教学、培训；健康知识讲座、养生知识科普的开放式公共平台。由北京润合公益基金会、北京天蔚中医药发展促进中心资助，北京蔚来高科技术有限公司技术开发服务。该平台致力于面向医务人员、医学院学生、有健康知识需求的群体，为提高专业知识、科普知识而设定。它结合了大规模、开放性和在线学习的特点。
            </p>
            <p align="left">
              &nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;www.幕课.com
              &nbsp; 旨在为全球医疗健康领域学习者提供高质量教育资源。<span
                style="color: black"
                >幕课</span
              >(MOOC)这种教育模式，
              通过互联网平台提供课程，允许任何人参与学习，不受地域和时间的限制。这种教育、培训模式在全球范围内迅速发展，极大地扩展了教育资源的可及性。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系我们 -->
    <div class="ontactusS">
      <div class="ontactusS-nate">
        <div class="ontactusS-left">
          <h5>幕课府学</h5>
          <h4>旨在为全球医疗健康学习者提供高质量教育资源</h4>
          <p>
            您是否还在为了如何设计课件而苦恼？为了课件不生动形象而发愁？想让学生一眼就能看懂课件内容，
            深入理解课程体系。本平台专为解决中医教学时课件展示方式不形象而提出解决方案。
          </p>
        </div>
        <div class="ontactusS-right">
          <el-button style="background: #4ccaff; color: #fff" @click="Contact()"
            >联系我们</el-button
          >
        </div>
        <div class="message"></div>
      </div>
    </div>
    <!-- 留言 -->
    <div class="cooperation">
      <div class="cooperation-one">
        <div class="cooperation-nav">
          <div class="service">
            <h5>
              <div>“</div>
              <span class="spans">课程合作</span>
              <div>”</div>
            </h5>
            <div class="servicex">Customized service</div>
          </div>
        </div>
        <div class="Input-box">
          <div class="inpts">
            <span>姓&nbsp;&nbsp;&nbsp;&nbsp;名&nbsp;:</span>
            <input type="text" v-model="name" />
          </div>
          <div class="interval"></div>
          <div class="inpts">
            <span style="width: 85px">联&nbsp;系&nbsp;方&nbsp;式&nbsp;:</span>
            <input type="text" v-model="phone" />
          </div>
        </div>
        <el-input
          class="input-area"
          maxlength="500"
          show-word-limit
          type="textarea"
          placeholder="请输入内容"
          v-model="hznr"
        >
        </el-input>
        <!-- <div class="submit" @click="inskczs()" v-preventReClick='3000' >提交留言</div> -->
        <el-button @click="inskczs()" class="submit" v-preventReClick="3000"
          >提交留言</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { inskcz } from "../../api/patient";
import Bus from "@/utils/bus";
export default {
  data() {
    return {
      name: "",
      phone: "",
      hznr: "",
    };
  },
  mounted() {
    Bus.$emit("activeRouter", "/aboutus");
  },
  methods: {
    goBottom() {
      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth",
      });
    },
    Contact() {
      window.scrollTo({
        top: 1400,
        behavior: "smooth",
      });
    },
    //   提交留言
    inskczs() {
      var ss = this.phone;
      var a = ss.split("");
      if (this.name !== "" && a.length === 11 && this.hznr !== "") {
        var data = new FormData();
        data.append("name", this.name);
        data.append("phone", this.phone);
        data.append("hznr", this.hznr);
        inskcz(data).then((rem) => {
          if (rem.code === "OK") {
            this.$message({
              showClose: true,
              message: rem.msg,
              type: "success",
            });
            this.phone = "";
            this.name = "";
            this.hznr = "";
          }
        });
      } else {
        if (this.hznr === "") {
          this.$message({
            showClose: true,
            message: "请填写完整",
            type: "warning",
          });
        } else if (this.name === "") {
          this.$message({
            showClose: true,
            message: "请填写完整姓名",
            type: "warning",
          });
        } else if (a.length !== 11) {
          this.$message({
            showClose: true,
            message: "请填写完整手机号码",
            type: "warning",
          });
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.aboutus {
  width: 100%;
  background: #fff;
  min-height: 100%;
  .image-container {
    width: 100%;
    position: relative;
    display: inline-block; /* Ensures the container is the size of the image */
    .aboutusimg {
      width: 100%;
    }
    .btn {
      position: absolute;
      left: 28%;
      top: 70%;
      background-color: #4ccaff;
      width: 194px;
      height: 50px;
      border-radius: 50px;
      font-size: 24px;
    }
  }

  .box {
    width: 1090px;
    margin: auto;
    .custom {
      margin-top: 69px;
      .service {
        h5 {
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #000000;
          display: flex;
          justify-content: center;
          height: 25px;
          margin-bottom: 10px;
          div {
            font-size: 58px;
            // font-family: PangMenZhengDao;
            font-weight: 400;
            color: #4ccaff;
            line-height: 50px;
          }
          .spans {
            margin: 0px 25px;
          }
        }
        .servicex {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #7c7c7c;
        }
      }
      .customx {
        ul {
          margin-top: 60px;
          display: flex;
          padding: 0 48px;
          justify-content: space-evenly;
          li {
            width: 215px;
            text-align: center;

            .round {
              width: 74px;
              height: 74px;
              -webkit-transition: all 0.5s linear;
              -moz-transition: all 0.5s linear;
              -o-transition: all 0.5s linear;
              transition: all 0.5s linear;
              background: #efefef;
              opacity: 0.6;
              border-radius: 50%;
              margin: auto;
              margin-bottom: 32px;
              .gos {
                font-size: 29px;
                color: #000;
                text-align: center;
                line-height: 74px;
                -webkit-transition: all 0.5s linear;
                -moz-transition: all 0.5s linear;
                -o-transition: all 0.5s linear;
                transition: all 0.5s linear;
                opacity: 0.8;
              }
            }
            .round:hover {
              -webkit-transition: all 0.5s linear;
              -moz-transition: all 0.5s linear;
              -o-transition: all 0.5s linear;
              transition: all 0.5s linear;
              background: #4ccaff;
              opacity: 1;
              .gos {
                -webkit-transition: all 0.5s linear;
                -moz-transition: all 0.5s linear;
                -o-transition: all 0.5s linear;
                transition: all 0.5s linear;
                font-size: 29px;
                color: #fff;
                text-align: center;
                line-height: 74px;
                opacity: 1;
              }
            }
            h4 {
              margin-bottom: 20px;
              font-size: 20px;
              font-family: Source Han Sans CN;
              font-weight: bold;
              color: #333333;
              // line-height: 38px;
            }
            p {
              font-size: 14px;
              font-family: Source Han Sans CN;
              font-weight: 400;
              color: #999999;
              line-height: 22px;
            }
          }
        }
      }
    }
  }
}

.introduce {
  margin-top: 81px;
  .service {
    margin-bottom: 66px;
    h5 {
      font-size: 26px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #000000;
      display: flex;
      justify-content: center;
      height: 25px;
      margin-bottom: 10px;
      div {
        font-size: 58px;
        // font-family: PangMenZhengDao;
        font-weight: 400;
        color: #4ccaff;
        line-height: 50px;
      }
      .spans {
        margin: 0px 25px;
      }
    }
    .servicex {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #7c7c7c;
    }
  }
  .introducex {
    display: flex;
    padding: 0 50px;
    margin-bottom: 61px;
    .introducex-x {
      width: 522px;
      height: 334px;
    }
    .introducex-rigth {
      width: 442px;
      height: 334px;
      padding-left: 48px;
      h4 {
        margin-top: 9px;
        text-align: left;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #010101;
        line-height: 16px;
      }
      h5 {
        text-align: left;

        font-size: 36px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #727272;
        line-height: 23px;
        margin: 17px 0px 33px 0px;
      }
      p {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999;
        line-height: 26px;
      }
    }
  }
}
.ontactusS {
  background: url("../../assets/bjlxwm.png") no-repeat;
  background-size: 100% 100%;
  height: 212px;
  .ontactusS-nate {
    width: 1010px;
    margin: auto;
    text-align: left;
    display: flex;

    .ontactusS-left {
      padding-top: 45px;
      width: 527px;
      h5 {
        // margin-bottomp: 45px;
        margin-bottom: 2px;
        font-size: 20px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      h4 {
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #666666;
        margin-bottom: 30px;
      }
      p {
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #999999;
      }
    }
    .ontactusS-right {
      margin-left: 289px;
      margin-top: 130px;
    }
  }
}
.cooperation {
  width: 1190px;
  // height: 500px;
  // background: red;
  margin: 0 auto;
  display: flex;
  .cooperation-one {
    // width: 100%;
    padding: 61px 50px 2px 71px;
    // display: flex;
    margin-bottom: 102px;
    .cooperation-nav {
      display: flex;
      justify-content: center;
      .service {
        h5 {
          font-size: 26px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #000000;
          display: flex;
          justify-content: center;
          height: 25px;
          margin-bottom: 10px;
          div {
            font-size: 58px;
            // font-family: PangMenZhengDao;
            font-weight: 400;
            color: #4ccaff;
            line-height: 50px;
          }
          .spans {
            margin: 0px 25px;
          }
        }
        .servicex {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #7c7c7c;
        }
      }
      h4 {
        // width: 90px;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #333333;
      }
      p {
        // width: 440px;
        // height: 16px;
        font-size: 15px;
        font-family: SourceHanSansCN-Regular;
        font-weight: 800;
        color: #cecece;
        line-height: 30px;
        margin-left: 6px;
      }
    }
    .Input-box {
      margin-top: 60px;
      display: flex;
      .interval {
        width: 23px;
      }
      .inpts {
        width: 509px;
        height: 50px;

        background: #ffffff;
        border: 1px solid #dedede;
        border-radius: 10px;
        display: flex;
        span {
          width: 52px;
          height: 16px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999999;
          line-height: 49.6px;
          padding-left: 32px;
          padding-right: 15px;
        }
        input {
          width: 80%;
          line-height: 50px;
          border: 0;
          color: #999999;
          border-radius: 10px;
          font-size: 16px;
        }
      }
    }
  }
}
.input-area {
  margin: 0px;
  margin-top: 20px;
}
::v-deep.el-textarea .el-input__count {
  right: 40px;
}
.el-textarea ::v-deep .el-textarea__inner {
  width: 1041px;
  height: 209px;
  background: #ffffff;
  border: 1px solid #dedede;
  border-radius: 10px;
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #999999;
  line-height: 21px;
  overflow: hidden;
  overflow: hidden;
  resize: none !important;
  padding: 20px 30px;
}

.submit {
  padding: 0px;
  width: 80px;
  height: 30px;
  line-height: 30px;
  background: #4ccaff;
  cursor: pointer;
  margin: auto;
  margin-top: 29px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  border-radius: 5px;
}
.submit {
  padding: 0px;
  width: 70px;
  height: 30px;
  line-height: 30px;
  background: #4ccaff;
  cursor: pointer;
  margin: auto;
  margin-top: 29px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #fff;
  border-radius: 5px;
}
.el-button:active {
  border-color: #4ccaff;
}
// 适配手机端
@media (max-width: 768px) {
  .aboutus {
    width: 100vw;
    .image-container {
      width: 100vw;
      height: 100px;
      .aboutusimg {
        width: 100vw;
        height: 100px;
      }
      .btn {
        width: 80px;
        height: 20px;
        line-height: 4px;
        border-radius: 40px;
        font-size: 12px;
      }
    }

    .box {
      width: 100vw;
      .custom {
        .service {
          h5 {
            font-size: 18px;
            margin-bottom: 5px;
            div {
              font-size: 28px;
              line-height: 30px;
            }
            .spans {
              margin: 0px 25px;
            }
          }
        }
        .customx {
          ul {
            width: 95vw;
            margin-top: 30px;
            display: flex;
            padding: 10px;
            justify-content: space-between;
            li {
              width: 80px;
              .round {
                width: 54px;
                height: 54px;
                .gos {
                  line-height: 54px;
                }
              }
              .round:hover {
                .gos {
                  line-height: 54px;
                }
              }
              h4 {
                font-size: 12px;
              }
              p {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }

  .introduce {
    margin-top: 61px;
    .service {
      margin-bottom: 46px;
      h5 {
        font-size: 18px;
        margin-bottom: 5px;
        div {
          font-size: 28px;
          line-height: 30px;
        }
        .spans {
          margin: 0px 25px;
        }
      }
    }
    .introducex {
      display: inherit;
      padding: 0 10px;
      .introducex-x {
        width: 95vw;
        height: 234px;
      }
      .introducex-rigth {
        width: 95vw;
        padding-left: 0px;
        padding-top: 20px;

        h5 {
          font-size: 26px;
        }
        p {
          font-size: 13px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #999;
          line-height: 26px;
        }
      }
    }
  }
  .ontactusS {
    width: 100vw;
    height: 200px;
    .ontactusS-nate {
      width: 95vw;
      margin: auto;
      text-align: left;
      display: inherit;

      .ontactusS-left {
        padding-top: 5px;
        padding-left: 10px;
        width: 95vw;
      }
      .ontactusS-right {
        margin-left: 38vw;
        margin-top: 10px;
      }
    }
  }
  .cooperation {
    width: 100vw;
    // height: 500px;
    // background: red;
    margin: 0 auto;
    display: flex;
    .cooperation-one {
      width: 95vw;
      padding: 61px 10px 10px 10px;
      .cooperation-nav {
        .service {
          h5 {
            font-size: 18px;
            div {
              font-size: 38px;
              line-height: 30px;
            }
            .spans {
              margin: 0px 25px;
            }
          }
        }
      }
      .Input-box {
        margin-top: 60px;
        display: flex;
        .interval {
          width: 23px;
        }
        .inpts {
          span {
            font-size: 12px;
            padding-left: 10px;
          }
          input {
            font-size: 12px;
          }
        }
      }
    }
  }
  .el-textarea ::v-deep .el-textarea__inner {
    width: 95vw;
  }

  .submit {
    padding: 0px;
    width: 80px;
    height: 30px;
    line-height: 30px;
    background: #4ccaff;
    cursor: pointer;
    margin: auto;
    margin-top: 29px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    border-radius: 5px;
  }
  .submit {
    padding: 0px;
    width: 70px;
    height: 30px;
    line-height: 30px;
    background: #4ccaff;
    cursor: pointer;
    margin: auto;
    margin-top: 29px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #fff;
    border-radius: 5px;
  }
  .el-button:active {
    border-color: #4ccaff;
  }
}
</style>
